import lazyLoadView from '@utils/lazy-load-view';
import roles from '@constants/roles';

export default {
	// prefix: 'somepath/',
	childof: 'inicio-view',
	routes: [
		{
			path: 'examenes',
			name: 'examenes',
			title: 'Examenes',
			meta: { ocupaRol: [roles.Administrador] },
			component: () => lazyLoadView(import('@views/examenes/examenes.vue'))
		},
		{
			path: 'examenes/detalle/:clave',
			name: 'detalleExamen',
			title: 'Detalle de exámen',
			meta: { ocupaRol: [roles.Administrador] },
			component: () =>
				lazyLoadView(import('@views/examenes/detalle/detalle.vue'))
		},
		{
			path: 'examenes/aspirantes/:clave',
			name: 'examenAspirantes',
			title: 'Exámen - Aspirantes',
			meta: { ocupaRol: [roles.Administrador] },
			component: () => lazyLoadView(import('@views/examenes/aspirantes.vue'))
		},
		{
			path: 'examenes/resultados/:clave',
			name: 'examenAspirantesResultados',
			title: 'Resultados Exámen - Aspirantes ',
			meta: { ocupaRol: [roles.Administrador] },
			component: () =>
				lazyLoadView(import('@views/examenes/aspirantes/resultados.vue'))
		},
		{
			path: 'examenes/aspirantes/:clave/:ficha',
			name: 'examenAspirantesDetalle',
			title: 'Resultados Exámen - Aspirante ',
			meta: { ocupaRol: [roles.Administrador] },
			component: () =>
				lazyLoadView(import('@views/examenes/aspirantes/detalle.vue'))
		},
		{
			path: 'examenes/detalleresultados/:clave',
			name: 'detalleExamenAspirantesResultados',
			title: 'Detalle de resultados Exámen - Aspirantes ',
			meta: { ocupaRol: [roles.Administrador] },
			component: () =>
				lazyLoadView(
					import('@views/examenes/aspirantes/rusultadosDetalles.vue')
				)
		}
	]
};
